(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     Nestling Chat Widget
     - AI agent (Claude) with site-aware knowledge
     - Human handoff: Messenger / Instagram / WhatsApp / Email
     - Per-language routing (BG / RO / DE / EN fallback → BG)
     ───────────────────────────────────────────────────────────── */

  const CONFIG = (window.NESTLING_CHAT_CONFIG = window.NESTLING_CHAT_CONFIG || {
    // Backend endpoint (Cloudflare Worker). When empty, falls back to mock AI for local preview.
    apiEndpoint: '',
    // Per-language social channels
    channels: {
      bg: {
        messenger:   'https://m.me/babykidsshop.eu',
        instagram:   'https://ig.me/m/nestlingbg',
        fbPage:      'https://www.facebook.com/babykidsshop.eu',
        messengerPageId: 'babykidsshop.eu'
      },
      ro: {
        messenger:   'https://m.me/61576506827674',
        instagram:   'https://ig.me/m/nestlingro',
        fbPage:      'https://www.facebook.com/profile.php?id=61576506827674',
        messengerPageId: '61576506827674'
      },
      de: { // German/Austrian customers default to the main inbox (we serve DE there)
        messenger:   'https://m.me/babykidsshop.eu',
        instagram:   'https://ig.me/m/nestlingbg',
        fbPage:      'https://www.facebook.com/babykidsshop.eu',
        messengerPageId: 'babykidsshop.eu'
      },
      en: { // English customers default to BG inbox (we serve EN there)
        messenger:   'https://m.me/babykidsshop.eu',
        instagram:   'https://ig.me/m/nestlingbg',
        fbPage:      'https://www.facebook.com/babykidsshop.eu',
        messengerPageId: 'babykidsshop.eu'
      }
    },
    whatsapp: 'https://wa.me/359878719194',
    email: 'info@babykidsshop.eu'
  });

  /* ─── Language detection ─────────────────────────────────────── */
  function detectLang() {
    // 1. Shopify locale (most reliable on the live store)
    const shopifyLang = window.Shopify && window.Shopify.locale;
    if (shopifyLang) {
      const code = shopifyLang.toLowerCase().slice(0, 2);
      if (['bg', 'ro', 'de', 'en'].includes(code)) return code;
    }
    // 2. <html lang="..">
    const htmlLang = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
    if (['bg', 'ro', 'de', 'en'].includes(htmlLang)) return htmlLang;
    // 3. Browser language
    const navLang = (navigator.language || 'en').toLowerCase().slice(0, 2);
    if (['bg', 'ro', 'de'].includes(navLang)) return navLang;
    return 'en';
  }

  /* ─── i18n ───────────────────────────────────────────────────── */
  const T = {
    bg: {
      title: 'Nestling Chat',
      subtitle: 'Обикновено отговаряме за минути',
      tabAI: 'Попитайте',
      tabHuman: 'Свържи се с нас',
      greet: 'Здравейте! 👋 Аз съм AI асистентът на Nestling. Мога да помогна с продукти, доставка, връщания или препоръки. Какво ви интересува?',
      placeholder: 'Напишете съобщение…',
      humanIntro: 'Изберете предпочитан канал — отговаряме обикновено в рамките на час.',
      chMessenger: 'Чат във Facebook',
      chMessengerSub: 'Отговор в Messenger app',
      chInstagram: 'Изпратете DM',
      chInstagramSub: 'Чат в Instagram',
      chWhatsapp: 'Пишете в WhatsApp',
      chWhatsappSub: 'Най-бърз отговор',
      chEmail: 'Изпратете имейл',
      chEmailSub: 'info@babykidsshop.eu',
      emailName: 'Вашето име',
      emailAddr: 'Имейл',
      emailMsg: 'Съобщение',
      emailSend: 'Изпрати',
      emailSent: '✓ Изпратено! Ще се свържем с вас скоро.',
      quickShipping: 'Доставка',
      quickReturns: 'Връщания',
      quickRecommend: 'Препоръка',
      quickOrder: '📦 Къде е поръчката ми',
      quickLive: '💬 Чат с оператор',
      quickLiveBadge: 'Препоръчано',
      liveStarted: 'Сега чатите с нашия екип. Обикновено отговаряме за минути.',
      liveOffline: 'Live чатът временно не е достъпен. Моля, използвайте WhatsApp или Messenger от „Свържи се с нас".',
      liveFailed: 'Грешка при изпращане. Опитайте отново или използвайте WhatsApp.',
      liveBackToAI: '↩︎ Към AI',
      quickHuman: 'Към оператор',
      disclaimer: 'AI може да греши. За точна информация — пишете на оператор.',
      thinking: 'Мисля…',
      orderRedirect: 'За проследяване на поръчка в реално време — пишете ни с **номера на поръчката**. Ще проверим и ще ви отговорим веднага. Изберете канал:',
      orderFormTitle: 'Проследяване на поръчка',
      orderNumPh: 'Номер на поръчка (напр. #1234)',
      orderEmailPh: 'Имейл при поръчката',
      orderSubmit: 'Провери статус',
      orderChecking: 'Проверявам…',
      orderNotFound: 'Не намерих поръчка с този номер. Проверете дали номерът е правилен.',
      orderEmailMismatch: 'Намерих поръчката, но имейлът не съвпада. Използвайте същия имейл, с който направихте поръчката.',
      orderUnavailable: 'Системата за проследяване е временно недостъпна. Моля, пишете ни през „Свържи се с нас".',
      orderProcessing: (n) => `Поръчка ${n} е получена и в процес на обработка. Ще получите имейл с проследяване веднага щом бъде изпратена.`,
      orderShipped: (n, c, num, url) => `Поръчка ${n} е изпратена${c ? ' с ' + c : ''}.${num ? ' Проследяване: ' + num + '.' : ''}${url ? ' [Проследи тук](' + url + ')' : ''}`,
      orderInTransit: (n, c, num, url) => `Поръчка ${n} е в път${c ? ' с ' + c : ''}.${num ? ' Проследяване: ' + num + '.' : ''}${url ? ' [Проследи тук](' + url + ')' : ''}`,
      orderOutForDelivery: (n, url) => `Поръчка ${n} е при куриера за доставка днес.${url ? ' [Проследи тук](' + url + ')' : ''}`,
      orderDelivered: (n, d) => `Поръчка ${n} беше доставена${d ? ' на ' + d : ''}. Надяваме се да сте доволни! Ако има проблем — пишете ни през „Свържи се с нас".`,
      orderFailed: (n) => `Поръчка ${n} имаше проблем с доставката. Моля, пишете ни през „Свържи се с нас" — ще проверим.`
    },
    ro: {
      title: 'Nestling Chat',
      subtitle: 'De obicei răspundem în câteva minute',
      tabAI: 'Întreabă',
      tabHuman: 'Contactează-ne',
      greet: 'Bună! 👋 Sunt asistentul AI al Nestling. Te pot ajuta cu produse, livrare, retururi sau recomandări. Cu ce te pot ajuta?',
      placeholder: 'Scrie un mesaj…',
      humanIntro: 'Alege canalul preferat — răspundem de obicei într-o oră.',
      chMessenger: 'Chat pe Facebook',
      chMessengerSub: 'Răspuns în Messenger',
      chInstagram: 'Trimite DM',
      chInstagramSub: 'Chat pe Instagram',
      chWhatsapp: 'Scrie pe WhatsApp',
      chWhatsappSub: 'Cel mai rapid',
      chEmail: 'Trimite email',
      chEmailSub: 'info@babykidsshop.eu',
      emailName: 'Numele tău',
      emailAddr: 'Email',
      emailMsg: 'Mesaj',
      emailSend: 'Trimite',
      emailSent: '✓ Trimis! Te vom contacta curând.',
      quickShipping: 'Livrare',
      quickReturns: 'Retururi',
      quickRecommend: 'Recomandare',
      quickOrder: '📦 Unde e comanda mea',
      quickLive: '💬 Chat cu operator',
      quickLiveBadge: 'Recomandat',
      liveStarted: 'Acum vorbești cu echipa noastră. De obicei răspundem în câteva minute.',
      liveOffline: 'Chat-ul live e temporar indisponibil. Te rog folosește WhatsApp sau Messenger din „Contactează-ne".',
      liveFailed: 'Eroare la trimitere. Încearcă din nou sau folosește WhatsApp.',
      liveBackToAI: '↩︎ Înapoi la AI',
      quickHuman: 'La operator',
      disclaimer: 'AI poate greși. Pentru informații exacte — scrie-i unui operator.',
      thinking: 'Mă gândesc…',
      orderRedirect: 'Pentru tracking în timp real al comenzii — scrie-ne cu **numărul comenzii**. Verificăm și răspundem imediat. Alege canalul:',
      orderFormTitle: 'Verificare comandă',
      orderNumPh: 'Număr comandă (ex. #1234)',
      orderEmailPh: 'Email folosit la comandă',
      orderSubmit: 'Verifică statusul',
      orderChecking: 'Verific…',
      orderNotFound: 'Nu am găsit nicio comandă cu acest număr. Verifică dacă numărul e corect.',
      orderEmailMismatch: 'Am găsit comanda, dar email-ul nu se potrivește. Folosește același email cu care ai plasat comanda.',
      orderUnavailable: 'Sistemul de tracking e temporar indisponibil. Te rog scrie-ne prin „Contactează-ne".',
      orderProcessing: (n) => `Comanda ${n} a fost primită și este în procesare. Vei primi email cu tracking imediat ce e expediată.`,
      orderShipped: (n, c, num, url) => `Comanda ${n} a fost expediată${c ? ' cu ' + c : ''}.${num ? ' Tracking: ' + num + '.' : ''}${url ? ' [Urmărește aici](' + url + ')' : ''}`,
      orderInTransit: (n, c, num, url) => `Comanda ${n} este pe drum${c ? ' cu ' + c : ''}.${num ? ' Tracking: ' + num + '.' : ''}${url ? ' [Urmărește aici](' + url + ')' : ''}`,
      orderOutForDelivery: (n, url) => `Comanda ${n} este la curier pentru livrare astăzi.${url ? ' [Urmărește aici](' + url + ')' : ''}`,
      orderDelivered: (n, d) => `Comanda ${n} a fost livrată${d ? ' pe ' + d : ''}. Sperăm că ești mulțumit! Dacă e vreo problemă — scrie-ne prin „Contactează-ne".`,
      orderFailed: (n) => `Comanda ${n} a avut o problemă la livrare. Te rog scrie-ne prin „Contactează-ne" — verificăm imediat.`
    },
    de: {
      title: 'Nestling Chat',
      subtitle: 'Wir antworten meist innerhalb von Minuten',
      tabAI: 'KI fragen',
      tabHuman: 'Kontakt',
      greet: 'Hallo! 👋 Ich bin der KI-Assistent von Nestling. Ich helfe bei Produkten, Versand, Rückgaben oder Empfehlungen. Wonach suchen Sie?',
      placeholder: 'Nachricht schreiben…',
      humanIntro: 'Wählen Sie Ihren bevorzugten Kanal — wir antworten meist innerhalb einer Stunde.',
      chMessenger: 'Chat auf Facebook',
      chMessengerSub: 'Antwort in der Messenger-App',
      chInstagram: 'DM senden',
      chInstagramSub: 'Chat auf Instagram',
      chWhatsapp: 'Auf WhatsApp schreiben',
      chWhatsappSub: 'Schnellste Antwort',
      chEmail: 'E-Mail senden',
      chEmailSub: 'info@babykidsshop.eu',
      emailName: 'Ihr Name',
      emailAddr: 'E-Mail',
      emailMsg: 'Nachricht',
      emailSend: 'Senden',
      emailSent: '✓ Gesendet! Wir melden uns in Kürze bei Ihnen.',
      quickShipping: 'Versand',
      quickReturns: 'Rückgabe',
      quickRecommend: 'Empfehlung',
      quickOrder: '📦 Wo ist meine Bestellung',
      quickLive: '💬 Mit dem Team chatten',
      quickLiveBadge: 'Empfohlen',
      liveStarted: 'Sie chatten jetzt mit unserem Team. Wir antworten meist innerhalb von Minuten.',
      liveOffline: 'Der Live-Chat ist vorübergehend nicht verfügbar. Bitte schreiben Sie uns über WhatsApp oder Messenger unter „Kontakt“.',
      liveFailed: 'Senden fehlgeschlagen. Bitte erneut versuchen oder WhatsApp nutzen.',
      liveBackToAI: '↩︎ Zurück zur KI',
      quickHuman: 'Zum Team',
      disclaimer: 'Die KI kann Fehler machen. Für verbindliche Auskunft — schreiben Sie unserem Team.',
      thinking: 'Einen Moment…',
      orderRedirect: 'Für die Sendungsverfolgung in Echtzeit — schreiben Sie uns mit Ihrer **Bestellnummer**. Wir prüfen das und antworten sofort. Wählen Sie einen Kanal:',
      orderFormTitle: 'Sendungsverfolgung',
      orderNumPh: 'Bestellnummer (z. B. #1234)',
      orderEmailPh: 'E-Mail aus der Bestellung',
      orderSubmit: 'Status prüfen',
      orderChecking: 'Wird geprüft…',
      orderNotFound: 'Zu dieser Nummer habe ich keine Bestellung gefunden. Bitte prüfen Sie die Nummer.',
      orderEmailMismatch: 'Die Bestellung habe ich gefunden, aber die E-Mail stimmt nicht überein. Bitte verwenden Sie dieselbe E-Mail wie bei der Bestellung.',
      orderUnavailable: 'Die Sendungsverfolgung ist vorübergehend nicht verfügbar. Bitte schreiben Sie uns über „Kontakt“.',
      orderProcessing: (n) => `Bestellung ${n} ist eingegangen und wird vorbereitet. Sobald sie versandt wird, erhalten Sie eine E-Mail mit der Sendungsverfolgung.`,
      orderShipped: (n, c, num, url) => `Bestellung ${n} wurde versandt${c ? ' mit ' + c : ''}.${num ? ' Sendungsnummer: ' + num + '.' : ''}${url ? ' [Hier verfolgen](' + url + ')' : ''}`,
      orderInTransit: (n, c, num, url) => `Bestellung ${n} ist unterwegs${c ? ' mit ' + c : ''}.${num ? ' Sendungsnummer: ' + num + '.' : ''}${url ? ' [Hier verfolgen](' + url + ')' : ''}`,
      orderOutForDelivery: (n, url) => `Bestellung ${n} ist heute beim Zusteller.${url ? ' [Hier verfolgen](' + url + ')' : ''}`,
      orderDelivered: (n, d) => `Bestellung ${n} wurde zugestellt${d ? ' am ' + d : ''}. Wir hoffen, Sie sind zufrieden! Falls etwas nicht stimmt, schreiben Sie uns über „Kontakt“.`,
      orderFailed: (n) => `Bei Bestellung ${n} gab es ein Zustellproblem. Bitte schreiben Sie uns über „Kontakt“ — wir kümmern uns darum.`
    },
    en: {
      title: 'Nestling Chat',
      subtitle: 'We usually reply within minutes',
      tabAI: 'Ask AI',
      tabHuman: 'Talk to us',
      greet: "Hi! 👋 I'm Nestling's AI assistant. I can help with products, shipping, returns, or recommendations. What are you looking for?",
      placeholder: 'Type a message…',
      humanIntro: 'Pick your preferred channel — we reply within an hour, usually.',
      chMessenger: 'Chat on Facebook',
      chMessengerSub: 'Reply in Messenger app',
      chInstagram: 'Send a DM',
      chInstagramSub: 'Chat on Instagram',
      chWhatsapp: 'Message on WhatsApp',
      chWhatsappSub: 'Fastest reply',
      chEmail: 'Send email',
      chEmailSub: 'info@babykidsshop.eu',
      emailName: 'Your name',
      emailAddr: 'Email',
      emailMsg: 'Message',
      emailSend: 'Send',
      emailSent: '✓ Sent! We will get back to you soon.',
      quickShipping: 'Shipping',
      quickReturns: 'Returns',
      quickRecommend: 'Recommend',
      quickOrder: '📦 Where is my order',
      quickLive: '💬 Chat with us live',
      quickLiveBadge: 'Recommended',
      liveStarted: "You're now chatting with our team. We usually reply within minutes.",
      liveOffline: 'Live chat is temporarily unavailable. Please reach us via WhatsApp or Messenger from "Talk to us".',
      liveFailed: 'Send failed. Try again or use WhatsApp.',
      liveBackToAI: '↩︎ Back to AI',
      quickHuman: 'Talk to human',
      disclaimer: 'AI may make mistakes. For exact info — talk to a human.',
      thinking: 'Thinking…',
      orderRedirect: 'For real-time order tracking — message us with your **order number**. We will check and reply right away. Pick a channel:',
      orderFormTitle: 'Order tracking',
      orderNumPh: 'Order number (e.g. #1234)',
      orderEmailPh: 'Email used at checkout',
      orderSubmit: 'Check status',
      orderChecking: 'Checking…',
      orderNotFound: "I couldn't find an order with that number. Please double-check it.",
      orderEmailMismatch: "I found the order but the email doesn't match. Please use the same email you used at checkout.",
      orderUnavailable: 'Tracking system is temporarily unavailable. Please reach us via "Talk to us".',
      orderProcessing: (n) => `Order ${n} has been received and is being prepared. You'll get a tracking email as soon as it ships.`,
      orderShipped: (n, c, num, url) => `Order ${n} has shipped${c ? ' with ' + c : ''}.${num ? ' Tracking: ' + num + '.' : ''}${url ? ' [Track it here](' + url + ')' : ''}`,
      orderInTransit: (n, c, num, url) => `Order ${n} is on its way${c ? ' via ' + c : ''}.${num ? ' Tracking: ' + num + '.' : ''}${url ? ' [Track it here](' + url + ')' : ''}`,
      orderOutForDelivery: (n, url) => `Order ${n} is out for delivery today.${url ? ' [Track it here](' + url + ')' : ''}`,
      orderDelivered: (n, d) => `Order ${n} was delivered${d ? ' on ' + d : ''}. We hope you're happy with it! If anything's wrong, reach us via "Talk to us".`,
      orderFailed: (n) => `Order ${n} ran into a delivery issue. Please reach us via "Talk to us" — we'll sort it out.`
    }
  };

  /* ─── Icons (inline SVG, no external deps) ───────────────────── */
  const ICONS = {
    chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    send: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 2-7 20-4-9-9-4 20-7Z"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    messenger: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.146 2 11.259c0 2.913 1.454 5.512 3.726 7.21V22l3.405-1.869c.908.252 1.87.388 2.869.388 5.523 0 10-4.146 10-9.259S17.523 2 12 2zm.994 12.461-2.546-2.715-4.971 2.715 5.469-5.808 2.609 2.715 4.908-2.715-5.469 5.808z"/></svg>',
    instagram: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>',
    whatsapp: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zm8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>',
    email: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>'
  };

  /* ─── State ──────────────────────────────────────────────────── */
  const LIVE_LS_KEY = 'nch_live_conv';
  const POLL_IDLE = 2500;          // default polling cadence when nothing is expected
  const POLL_ACTIVE = 800;         // fast polling immediately after customer sends a message
  const POLL_ACTIVE_DURATION = 25000; // stay in fast mode this long after a send

  const state = {
    lang: detectLang(),
    open: false,
    view: 'ai',        // 'ai' | 'human'
    mode: 'ai',        // 'ai' | 'live' — drives where the input sends messages
    history: [],
    busy: false,
    liveConvId: null,
    liveSince: 0,
    livePollTimer: null,
    liveActiveUntil: 0
  };
  const t = (k) => (T[state.lang] && T[state.lang][k]) || T.en[k] || k;
  const ch = () => CONFIG.channels[state.lang] || CONFIG.channels.bg;

  /* ─── DOM build ─────────────────────────────────────────────── */
  function el(tag, attrs, ...children) {
    const e = document.createElement(tag);
    for (const k in (attrs || {})) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else if (k.startsWith('on')) e.addEventListener(k.slice(2), attrs[k]);
      else e.setAttribute(k, attrs[k]);
    }
    children.flat().forEach((c) => {
      if (c == null) return;
      e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return e;
  }

  function buildChannelCard(iconClass, iconSvg, title, sub, href, onClick) {
    // Real href + onClick. External links get target=_blank rel=noopener for crawler/a11y safety.
    // If href is null/'#' (e.g. email form toggle), the onClick handler is the action and we prevent default.
    var isExternal = href && /^(https?:|mailto:|tel:)/i.test(href);
    var attrs = {
      class: 'nch-channel',
      href: href || '#',
      onclick: function (e) {
        if (!isExternal) { e.preventDefault(); }
        if (typeof onClick === 'function') return onClick(e);
      }
    };
    if (isExternal && /^https?:/i.test(href)) {
      attrs.target = '_blank';
      attrs.rel = 'noopener';
    }
    return el('a', attrs,
      el('div', { class: 'nch-channel-icon ' + iconClass, html: iconSvg }),
      el('div', { class: 'nch-channel-text' },
        el('div', { class: 'nch-channel-title' }, title),
        el('div', { class: 'nch-channel-sub' }, sub)
      ),
      el('div', { class: 'nch-channel-arrow', html: ICONS.arrow })
    );
  }

  function openExternal(url) { window.open(url, '_blank', 'noopener'); }

  let root, panel, body, aiView, humanView, input, sendBtn, typingEl;

  function mount() {
    root = el('div', { id: 'nch-root' });

    // Bubble
    const bubble = el('button', { class: 'nch-bubble', 'aria-label': 'Open chat', onclick: togglePanel, html: ICONS.chat });
    bubble.appendChild(el('span', { class: 'nch-bubble-dot' }));

    // Panel
    panel = el('div', { class: 'nch-panel', role: 'dialog' });

    // Header
    const header = el('div', { class: 'nch-header' },
      el('div', { class: 'nch-avatar' }, 'N'),
      el('div', { style: 'flex:1' },
        el('div', { class: 'nch-header-title' }, t('title')),
        el('div', { class: 'nch-header-sub' }, t('subtitle'))
      ),
      el('button', { class: 'nch-close', 'aria-label': 'Close', onclick: togglePanel, html: ICONS.close })
    );

    // Tabs
    const tabs = el('div', { class: 'nch-tabs' },
      el('button', { class: 'nch-tab nch-tab-active', 'data-view': 'ai', onclick: () => switchView('ai') }, t('tabAI')),
      el('button', { class: 'nch-tab', 'data-view': 'human', onclick: () => switchView('human') }, t('tabHuman'))
    );

    // Body container
    body = el('div', { class: 'nch-body' });
    aiView = el('div', { class: 'nch-view nch-view-active', 'data-view': 'ai' });
    humanView = el('div', { class: 'nch-view', 'data-view': 'human' });
    body.appendChild(aiView);
    body.appendChild(humanView);

    // AI view initial content
    aiView.appendChild(el('div', { class: 'nch-msg nch-msg-ai' }, t('greet')));
    const quick = el('div', { class: 'nch-quick' },
      el('button', { class: 'nch-chip nch-chip--live', onclick: () => startLiveChat() },
        el('span', { class: 'nch-chip__label' }, t('quickLive')),
        el('span', { class: 'nch-chip__badge' }, t('quickLiveBadge'))
      ),
      el('button', { class: 'nch-chip', onclick: () => handleOrderChip() }, t('quickOrder')),
      el('button', { class: 'nch-chip', onclick: () => sendUserMessage(t('quickShipping') + '?') }, t('quickShipping')),
      el('button', { class: 'nch-chip', onclick: () => sendUserMessage(t('quickReturns') + '?') }, t('quickReturns')),
      el('button', { class: 'nch-chip', onclick: () => sendUserMessage(t('quickRecommend') + '?') }, t('quickRecommend'))
    );
    aiView.appendChild(quick);

    // Human view
    humanView.appendChild(el('div', { class: 'nch-channels-intro' }, t('humanIntro')));
    humanView.appendChild(buildChannelCard('nch-ic-messenger', ICONS.messenger, t('chMessenger'), t('chMessengerSub'), ch().messenger, () => openExternal(ch().messenger)));
    humanView.appendChild(buildChannelCard('nch-ic-instagram', ICONS.instagram, t('chInstagram'), t('chInstagramSub'), ch().instagram, () => openExternal(ch().instagram)));
    humanView.appendChild(buildChannelCard('nch-ic-whatsapp', ICONS.whatsapp, t('chWhatsapp'), t('chWhatsappSub'), CONFIG.whatsapp, () => openExternal(CONFIG.whatsapp)));
    const emailCard = buildChannelCard('nch-ic-email', ICONS.email, t('chEmail'), t('chEmailSub'), null, toggleEmailForm);
    humanView.appendChild(emailCard);

    // Email form
    const emailForm = el('form', { class: 'nch-email-form', id: 'nch-email-form', onsubmit: handleEmailSubmit },
      el('input', { type: 'text', name: 'name', placeholder: t('emailName'), required: 'required' }),
      el('input', { type: 'email', name: 'email', placeholder: t('emailAddr'), required: 'required' }),
      el('textarea', { name: 'message', placeholder: t('emailMsg'), required: 'required' }),
      el('button', { type: 'submit' }, t('emailSend'))
    );
    humanView.appendChild(emailForm);

    // Footer (input)
    const footer = el('div', { class: 'nch-footer' });
    input = el('textarea', { class: 'nch-input', placeholder: t('placeholder'), rows: '1' });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        const v = input.value.trim();
        if (v) sendUserMessage(v);
      }
    });
    input.addEventListener('input', () => {
      input.style.height = 'auto';
      input.style.height = Math.min(input.scrollHeight, 120) + 'px';
    });
    sendBtn = el('button', { class: 'nch-send', 'aria-label': 'Send', onclick: () => {
      const v = input.value.trim();
      if (v) sendUserMessage(v);
    }, html: ICONS.send });
    footer.appendChild(el('div', { class: 'nch-input-wrap' }, input, sendBtn));
    footer.appendChild(el('div', { class: 'nch-disclaimer' }, t('disclaimer')));

    panel.appendChild(header);
    panel.appendChild(tabs);
    panel.appendChild(body);
    panel.appendChild(footer);

    root.appendChild(bubble);
    root.appendChild(panel);
    document.body.appendChild(root);
  }

  function togglePanel() {
    state.open = !state.open;
    panel.classList.toggle('nch-open', state.open);
    if (state.open) setTimeout(() => input && input.focus(), 250);
  }

  function switchView(v) {
    state.view = v;
    root.querySelectorAll('.nch-tab').forEach((b) => {
      b.classList.toggle('nch-tab-active', b.getAttribute('data-view') === v);
    });
    root.querySelectorAll('.nch-view').forEach((vEl) => {
      vEl.classList.toggle('nch-view-active', vEl.getAttribute('data-view') === v);
    });
    // hide input footer in human mode
    root.querySelector('.nch-footer').style.display = v === 'ai' ? '' : 'none';
  }

  function toggleEmailForm() {
    const f = root.querySelector('#nch-email-form');
    f.classList.toggle('nch-open');
  }

  function appendMsg(role, text) {
    const m = el('div', { class: 'nch-msg ' + (role === 'user' ? 'nch-msg-user' : 'nch-msg-ai') });
    // Render minimal markdown links [text](url) → real <a> tags; plain text otherwise.
    const safe = String(text).replace(/[<>]/g, (c) => c === '<' ? '&lt;' : '&gt;');
    m.innerHTML = safe.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
      (_, label, url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${label}</a>`
    );
    aiView.appendChild(m);
    body.scrollTop = body.scrollHeight;
    return m;
  }

  function handleOrderChip() {
    // Avoid duplicates
    if (aiView.querySelector('[data-order-redirect]')) return;
    // Render an AI message that contains inline channel buttons (Messenger + WhatsApp).
    // Per-language routing for Messenger / Instagram comes from CONFIG.channels[lang].
    appendMsg('user', t('quickOrder'));
    const wrap = el('div', { class: 'nch-msg nch-msg-ai', 'data-order-redirect': '1' });
    const text = String(t('orderRedirect'))
      .replace(/[<>]/g, (c) => c === '<' ? '&lt;' : '&gt;')
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    wrap.innerHTML = text;
    aiView.appendChild(wrap);

    const buttons = el('div', { class: 'nch-quick' },
      el('a', { class: 'nch-chip', href: CONFIG.whatsapp, target: '_blank', rel: 'noopener', style: 'background:#25D366;color:#fff;border-color:#25D366' }, '💬 WhatsApp'),
      el('a', { class: 'nch-chip', href: ch().messenger, target: '_blank', rel: 'noopener', style: 'background:#006AFF;color:#fff;border-color:#006AFF' }, '💬 Messenger')
    );
    aiView.appendChild(buttons);
    body.scrollTop = body.scrollHeight;
  }

  function showOrderForm() {
    // Avoid duplicate forms
    if (aiView.querySelector('.nch-inline-form[data-form="order"]')) return;
    const form = el('form', { class: 'nch-inline-form', 'data-form': 'order', onsubmit: handleOrderLookup },
      el('div', { class: 'nch-inline-form-title' }, t('orderFormTitle')),
      el('input', { type: 'text', name: 'orderName', placeholder: t('orderNumPh'), required: 'required', autocomplete: 'off' }),
      el('input', { type: 'email', name: 'email', placeholder: t('orderEmailPh'), required: 'required' }),
      el('button', { type: 'submit' }, t('orderSubmit'))
    );
    aiView.appendChild(form);
    body.scrollTop = body.scrollHeight;
  }

  async function handleOrderLookup(e) {
    e.preventDefault();
    const form = e.target;
    const orderName = form.orderName.value.trim();
    const email = form.email.value.trim();
    const btn = form.querySelector('button');
    btn.disabled = true; btn.textContent = t('orderChecking');

    // Echo the user's action as a user message, then remove the form.
    appendMsg('user', orderName + ' · ' + email);
    form.remove();
    showTyping();

    try {
      const endpoint = CONFIG.apiEndpoint ? CONFIG.apiEndpoint.replace(/\/chat$/, '/order') : '';
      let data;
      if (endpoint) {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ orderName, email, lang: state.lang })
        });
        data = await res.json();
      } else {
        // Local preview fallback — fabricate a "shipped" demo response so user can see the flow.
        await new Promise((r) => setTimeout(r, 700));
        data = {
          found: true,
          orderName: orderName.startsWith('#') ? orderName : '#' + orderName,
          fulfillmentStatus: 'fulfilled',
          tracking: { shipmentStatus: 'in_transit', number: 'JD0123456789', url: 'https://example.com/track/JD0123456789', company: 'DHL' }
        };
      }
      hideTyping();
      appendMsg('assistant', formatOrderReply(data));
    } catch (err) {
      hideTyping();
      appendMsg('assistant', t('orderUnavailable'));
      console.error('[Nestling Chat] order lookup error', err);
    }
  }

  function formatOrderReply(data) {
    if (!data || !data.found) {
      if (data && data.reason === 'email_mismatch') return t('orderEmailMismatch');
      if (data && data.reason === 'lookup_unavailable') return t('orderUnavailable');
      return t('orderNotFound');
    }
    const n = data.orderName;
    const tr = data.tracking || {};
    const ship = tr.shipmentStatus;
    const dateStr = tr.updatedAt ? new Date(tr.updatedAt).toLocaleDateString(state.lang === 'bg' ? 'bg-BG' : state.lang === 'ro' ? 'ro-RO' : state.lang === 'de' ? 'de-AT' : 'en-GB') : '';

    if (ship === 'delivered') return t('orderDelivered')(n, dateStr);
    if (ship === 'out_for_delivery') return t('orderOutForDelivery')(n, tr.url);
    if (ship === 'in_transit' || ship === 'attempted_delivery') return t('orderInTransit')(n, tr.company, tr.number, tr.url);
    if (ship === 'failure') return t('orderFailed')(n);
    if (data.fulfillmentStatus === 'fulfilled' && !ship) return t('orderShipped')(n, tr.company, tr.number, tr.url);
    return t('orderProcessing')(n);
  }

  function showTyping() {
    typingEl = el('div', { class: 'nch-typing' }, el('span'), el('span'), el('span'));
    aiView.appendChild(typingEl);
    body.scrollTop = body.scrollHeight;
  }
  function hideTyping() { if (typingEl) { typingEl.remove(); typingEl = null; } }

  async function sendUserMessage(text) {
    if (state.busy) return;
    // Route to live-chat backend when in live mode.
    if (state.mode === 'live') {
      return sendLiveMessage(text);
    }
    state.busy = true;
    input.value = ''; input.style.height = 'auto';
    appendMsg('user', text);
    state.history.push({ role: 'user', content: text });
    showTyping();

    try {
      const reply = await callAI(text);
      hideTyping();
      appendMsg('assistant', reply);
      state.history.push({ role: 'assistant', content: reply });
    } catch (err) {
      hideTyping();
      appendMsg('assistant', state.lang === 'bg'
        ? 'Технически проблем. Моля, опитайте „Свържи се с нас".'
        : state.lang === 'ro'
          ? 'Problemă tehnică. Te rog folosește „Contactează-ne".'
          : state.lang === 'de'
            ? 'Technisches Problem. Bitte nutzen Sie „Kontakt“.'
            : 'Technical issue. Please use "Talk to us".');
      console.error('[Nestling Chat] AI error', err);
    }
    state.busy = false;
  }

  /* ─── Live chat (Telegram relay) ─────────────────────────────── */

  async function startLiveChat() {
    if (!CONFIG.apiEndpoint) {
      appendMsg('assistant', t('liveOffline'));
      return;
    }
    // Reuse existing conversation if one#is stored in localStorage.
    let convId = null;
    try {
      const cached = JSON.parse(localStorage.getItem(LIVE_LS_KEY) || 'null');
      if (cached && cached.convId && cached.lang === state.lang &&
          (Date.now() - cached.createdAt) < 6 * 60 * 60 * 1000) {
        convId = cached.convId;
      }
    } catch {}

    if (!convId) {
      try {
        const endpoint = CONFIG.apiEndpoint.replace(/\/chat$/, '/human/start');
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ lang: state.lang, page: { url: location.href, title: document.title } })
        });
        const data = await res.json();
        if (!data.convId || !data.ownerOnline) {
          appendMsg('assistant', t('liveOffline'));
          return;
        }
        convId = data.convId;
        try {
          localStorage.setItem(LIVE_LS_KEY, JSON.stringify({ convId, lang: state.lang, createdAt: Date.now() }));
        } catch {}
      } catch (err) {
        console.error('[Nestling Chat] live start failed', err);
        appendMsg('assistant', t('liveOffline'));
        return;
      }
    }

    state.mode = 'live';
    state.liveConvId = convId;
    state.liveSince = 0;
    appendMsg('assistant', t('liveStarted'));

    // Remove the quick-action chips while in live mode (they'd cancel out the live session).
    const oldQuick = aiView.querySelector('.nch-quick');
    if (oldQuick) oldQuick.remove();

    // Add a "back to AI" chip
    const back = el('div', { class: 'nch-quick' },
      el('button', { class: 'nch-chip', onclick: () => exitLiveChat() }, t('liveBackToAI'))
    );
    aiView.appendChild(back);

    startLivePoll();
  }

  function exitLiveChat() {
    state.mode = 'ai';
    state.liveConvId = null;
    state.liveSince = 0;
    if (state.livePollTimer) { clearInterval(state.livePollTimer); state.livePollTimer = null; }
    try { localStorage.removeItem(LIVE_LS_KEY); } catch {}
    // Append a small system note
    appendMsg('assistant', t('greet'));
  }

  async function sendLiveMessage(text) {
    if (!state.liveConvId) return;
    state.busy = true;
    input.value = ''; input.style.height = 'auto';
    appendMsg('user', text);
    try {
      const endpoint = CONFIG.apiEndpoint.replace(/\/chat$/, '/human/message');
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ convId: state.liveConvId, text })
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      // Speed up polling for ~25s — owner is likely about to reply.
      state.liveActiveUntil = Date.now() + POLL_ACTIVE_DURATION;
      schedulePoll(true);
    } catch (err) {
      appendMsg('assistant', t('liveFailed'));
      console.error('[Nestling Chat] live send failed', err);
    }
    state.busy = false;
  }

  function startLivePoll() {
    schedulePoll(false);
    pollLive(); // fire one immediately
  }

  function schedulePoll(immediate) {
    if (state.livePollTimer) clearTimeout(state.livePollTimer);
    const cadence = (Date.now() < state.liveActiveUntil) ? POLL_ACTIVE : POLL_IDLE;
    state.livePollTimer = setTimeout(pollLive, immediate ? cadence : cadence);
  }

  async function pollLive() {
    if (state.mode !== 'live' || !state.liveConvId) return;
    try {
      const endpoint = CONFIG.apiEndpoint.replace(/\/chat$/, '/human/poll') +
        `?conv_id=${encodeURIComponent(state.liveConvId)}&since=${state.liveSince}`;
      const res = await fetch(endpoint);
      if (res.ok) {
        const data = await res.json();
        if (data.messages && data.messages.length) {
          data.messages.forEach((m) => {
            appendMsg('assistant', m.text);
            if (m.ts > state.liveSince) state.liveSince = m.ts;
          });
          // New message arrived — extend the active window so we stay fast.
          state.liveActiveUntil = Date.now() + POLL_ACTIVE_DURATION;
        }
      }
    } catch (err) {
      // Silent — schedule another attempt.
    }
    if (state.mode === 'live') schedulePoll(false);
  }

  async function callAI(message) {
    if (!CONFIG.apiEndpoint) {
      // Mock fallback for local preview
      await new Promise((r) => setTimeout(r, 600 + Math.random() * 600));
      return mockReply(message);
    }
    const res = await fetch(CONFIG.apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        lang: state.lang,
        history: state.history.slice(-12),
        page: { url: location.href, title: document.title }
      })
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const data = await res.json();
    return data.reply || '';
  }

  function mockReply(msg) {
    const m = msg.toLowerCase();
    const replies = {
      bg: {
        ship:  'Доставка в целия ЕС е безплатна, без минимална поръчка. Обработка 1–2 работни дни, доставка 3–8 работни дни — общо 4–10 работни дни.',
        ret:   'Имате 30 дни за връщане. Продуктът трябва да е неизползван, с оригинална опаковка и етикети. Транспортът за връщане е за сметка на клиента — освен ако стоката е дефектна или сме изпратили грешен артикул, тогава ние поемаме разходите.',
        pay:   'Приемаме Visa, Mastercard, Amex, PayPal, Apple Pay и Google Pay. Всички плащания са SSL защитени.',
        rec:   'Кажете ми възраст на детето и какво търсите (играчка, мебели, обзавеждане, активна игра) — ще препоръчам нещо подходящо.',
        def:   '(Демо отговор) Тук ще говори AI с пълна информация за магазина. За реални отговори — деплойнете Cloudflare Worker-а.'
      },
      ro: {
        ship:  'Livrare gratuită în toată Uniunea Europeană, fără comandă minimă. Procesare 1–2 zile lucrătoare, livrare 3–8 zile — total 4–10 zile lucrătoare.',
        ret:   'Aveți 30 de zile pentru retur. Produsul trebuie să fie nefolosit, cu ambalajul și etichetele originale. Transportul pentru retur este plătit de client — excepție: dacă produsul este defect sau am trimis articol greșit, costul îl suportăm noi.',
        pay:   'Acceptăm Visa, Mastercard, Amex, PayPal, Apple Pay și Google Pay. Toate tranzacțiile sunt securizate SSL.',
        rec:   'Spuneți-mi vârsta copilului și ce căutați (jucărie, mobilier, joc activ) — voi recomanda ceva potrivit.',
        def:   '(Răspuns demo) Aici va răspunde AI-ul cu informații complete despre magazin. Pentru răspunsuri reale — implementați Cloudflare Worker-ul.'
      },
      de: {
        ship:  'Kostenloser Versand in die gesamte EU, ohne Mindestbestellwert. Bearbeitung 1–2 Werktage, Zustellung 3–8 Werktage — insgesamt 4–10 Werktage.',
        ret:   '30 Tage Rückgaberecht. Der Artikel muss unbenutzt sein, mit Originalverpackung und Etiketten. Die Rücksendekosten tragen Sie — außer der Artikel kam beschädigt an oder wir haben den falschen geschickt, dann übernehmen wir sie.',
        pay:   'Wir akzeptieren Visa, Mastercard, Amex, PayPal, Apple Pay und Google Pay. Alle Zahlungen sind SSL-gesichert.',
        rec:   'Sagen Sie mir das Alter des Kindes und wonach Sie suchen (Spielzeug, Möbel, Bewegungsspiel) — ich empfehle Ihnen etwas Passendes.',
        def:   '(Demo-Antwort) Hier antwortet die KI mit vollem Shop-Wissen. Für echte Antworten den Cloudflare Worker deployen.'
      },
      en: {
        ship:  'Free shipping across the entire EU, no minimum order. Processing 1–2 business days, delivery 3–8 business days — total 4–10 business days.',
        ret:   '30 days to return. Item must be unused with original packaging and labels. Return shipping is paid by the customer — unless the item arrived damaged or we sent the wrong one, then we cover it.',
        pay:   'We accept Visa, Mastercard, Amex, PayPal, Apple Pay and Google Pay. All transactions are SSL-secured.',
        rec:   "Tell me the child's age and what you're after (toy, furniture, active play) — I'll recommend something.",
        def:   '(Demo reply) The real AI will answer with full store knowledge. Deploy the Cloudflare Worker for real replies.'
      }
    };
    const lang = replies[state.lang] || replies.en;
    if (/ship|delivery|versand|liefer|доставк|livrar/.test(m)) return lang.ship;
    if (/return|rückgab|rucksend|rücksend|връща|retur/.test(m)) return lang.ret;
    if (/pay|card|zahl|bezahl|плащан|плати|plată|plat[ăa]/.test(m)) return lang.pay;
    if (/recommend|empfehl|препор|recoman/.test(m)) return lang.rec;
    return lang.def;
  }

  async function handleEmailSubmit(e) {
    e.preventDefault();
    const f = e.target;
    const data = {
      name: f.name.value, email: f.email.value, message: f.message.value, lang: state.lang
    };
    const btn = f.querySelector('button');
    btn.disabled = true; btn.textContent = '…';
    try {
      if (CONFIG.apiEndpoint) {
        await fetch(CONFIG.apiEndpoint.replace(/\/chat$/, '/email'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });
      } else {
        // Local preview: fall back to mailto
        const subject = encodeURIComponent('Запитване от сайта — ' + data.name);
        const bodyT = encodeURIComponent(data.message + '\n\n— ' + data.name + ' (' + data.email + ')');
        window.location.href = 'mailto:' + CONFIG.email + '?subject=' + subject + '&body=' + bodyT;
      }
      f.innerHTML = '<div style="text-align:center;padding:12px;color:var(--nch-text)">' + t('emailSent') + '</div>';
    } catch (err) {
      btn.disabled = false; btn.textContent = t('emailSend');
      console.error('[Nestling Chat] email error', err);
    }
  }

  /* ─── Init ───────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
